import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-medium-emphasis"
}
const _hoisted_2 = {
  key: 0,
  class: "text-caption text-error font-weight-bold mb-2"
}
const _hoisted_3 = { class: "d-flex justify-space-between align-center mb-1" }
const _hoisted_4 = { class: "font-weight-medium" }
const _hoisted_5 = { class: "d-flex justify-space-between align-center mb-1" }
const _hoisted_6 = {
  key: 2,
  class: "text-caption text-medium-emphasis font-weight-bold mb-2"
}
const _hoisted_7 = { class: "d-flex justify-space-between align-center mb-1" }
const _hoisted_8 = { class: "font-weight-medium" }
const _hoisted_9 = { class: "d-flex justify-space-between align-center mb-1" }
const _hoisted_10 = { class: "d-flex justify-space-between align-center mb-1" }
const _hoisted_11 = { class: "d-flex justify-space-between align-center mb-1" }
const _hoisted_12 = { class: "font-mono" }
const _hoisted_13 = { class: "d-flex justify-space-between align-center" }
const _hoisted_14 = { class: "d-flex justify-space-between font-weight-bold px-4 py-1" }
const _hoisted_15 = { class: "text-h3 font-weight-bold mt-2 text-blue" }
const _hoisted_16 = { class: "text-h3 font-weight-bold mt-2 text-success" }
const _hoisted_17 = { class: "text-caption text-medium-emphasis mt-2" }
const _hoisted_18 = { class: "text-h3 font-weight-bold mt-2 text-orange" }
const _hoisted_19 = { class: "text-caption text-medium-emphasis mt-2" }
const _hoisted_20 = { class: "text-h3 font-weight-bold mt-2 text-error" }
const _hoisted_21 = { class: "text-caption text-medium-emphasis mt-2" }
const _hoisted_22 = { class: "text-h3 font-weight-bold mt-2 text-purple" }
const _hoisted_23 = { class: "text-caption text-medium-emphasis mt-2" }
const _hoisted_24 = { class: "d-flex align-center flex-wrap ga-4 mb-4" }
const _hoisted_25 = { class: "font-mono font-weight-bold" }
const _hoisted_26 = { class: "font-weight-bold" }
const _hoisted_27 = { class: "text-medium-emphasis" }
const _hoisted_28 = {
  key: 1,
  class: "text-caption text-medium-emphasis"
}
const _hoisted_29 = { class: "text-medium-emphasis" }
const _hoisted_30 = { class: "font-weight-medium" }
const _hoisted_31 = {
  key: 0,
  class: "text-medium-emphasis"
}
const _hoisted_32 = {
  key: 0,
  class: "text-error text-caption font-weight-medium"
}
const _hoisted_33 = {
  key: 1,
  class: "text-success text-caption font-weight-medium"
}
const _hoisted_34 = {
  key: 2,
  class: "text-orange text-caption font-weight-medium"
}
const _hoisted_35 = {
  key: 3,
  class: "text-error text-caption font-weight-medium"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WaitDialog = _resolveComponent("WaitDialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_m_btn = _resolveComponent("m-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_WaitDialog, {
      isActive: $setup.isWaiting,
      title: "Fetching batch runs..."
    }, null, 8 /* PROPS */, ["isActive"]),
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_navigation_drawer, {
          modelValue: $setup.overlayViewForms,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.overlayViewForms) = $event)),
          location: "right",
          temporary: "",
          width: "400"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { flat: "" }, {
              default: _withCtx(() => [
                ($setup.batchPolicySummary)
                  ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.batchPolicySummary.policyNumber) + " Form Codes ", 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    ($setup.batchPolicySummary)
                      ? (_openBlock(), _createBlock(_component_v_list, { key: 0 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.batchPolicySummary.formCodes, (formCode, index) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, { key: index }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(formCode), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _createVNode(_component_v_navigation_drawer, {
          modelValue: $setup.overlayPrintConfirmations,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.overlayPrintConfirmations) = $event)),
          location: "right",
          temporary: "",
          width: "440"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { flat: "" }, {
              default: _withCtx(() => [
                ($setup.printConfirmationPolicy)
                  ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.printConfirmationPolicy) + " Print Confirmations ", 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    ($setup.printConfirmationDetails.length === 0 && $setup.printMissingPieces.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " No print confirmations were reported for this policy. "))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createCommentVNode(" Missing pieces first, highlighted in red "),
                          ($setup.printMissingPieces.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Not Mailed (" + _toDisplayString($setup.printMissingPieces.length) + ") ", 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          ($setup.printMissingPieces.length > 0)
                            ? (_openBlock(), _createBlock(_component_v_list, {
                                key: 1,
                                class: "pt-0"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.printMissingPieces, (miss, index) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 'miss-' + index,
                                      class: "px-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card, {
                                          variant: "outlined",
                                          color: "error",
                                          class: "mb-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_card_text, null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_3, [
                                                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-caption text-medium-emphasis font-weight-bold" }, "Batch", -1 /* HOISTED */)),
                                                  _createElementVNode("span", _hoisted_4, _toDisplayString(miss.batchName), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("div", _hoisted_5, [
                                                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-caption text-medium-emphasis font-weight-bold" }, "Recipient", -1 /* HOISTED */)),
                                                  _createElementVNode("span", null, _toDisplayString(miss.party || 'N/A'), 1 /* TEXT */)
                                                ]),
                                                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "d-flex justify-space-between align-center" }, [
                                                  _createElementVNode("span", { class: "text-caption text-medium-emphasis font-weight-bold" }, "Status"),
                                                  _createElementVNode("span", { class: "text-error font-weight-medium" }, "Not Mailed")
                                                ], -1 /* HOISTED */))
                                              ]),
                                              _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _: 1 /* STABLE */
                              }))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" Mailed pieces "),
                          ($setup.printConfirmationDetails.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Mailed (" + _toDisplayString($setup.printConfirmationDetails.length) + ") ", 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          ($setup.printConfirmationDetails.length > 0)
                            ? (_openBlock(), _createBlock(_component_v_list, {
                                key: 3,
                                class: "pt-0"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.printConfirmationDetails, (confirmation, index) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: index,
                                      class: "px-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card, {
                                          variant: "tonal",
                                          class: "mb-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_card_text, null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_7, [
                                                  _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-caption text-medium-emphasis font-weight-bold" }, "Batch", -1 /* HOISTED */)),
                                                  _createElementVNode("span", _hoisted_8, _toDisplayString(confirmation.batchName), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("div", _hoisted_9, [
                                                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-caption text-medium-emphasis font-weight-bold" }, "Vendor", -1 /* HOISTED */)),
                                                  _createElementVNode("span", null, _toDisplayString(confirmation.vendor || 'N/A'), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("div", _hoisted_10, [
                                                  _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-caption text-medium-emphasis font-weight-bold" }, "Printed", -1 /* HOISTED */)),
                                                  _createElementVNode("span", null, _toDisplayString(confirmation.printDateTime || 'N/A'), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("div", _hoisted_11, [
                                                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-caption text-medium-emphasis font-weight-bold" }, "Sequence #", -1 /* HOISTED */)),
                                                  _createElementVNode("span", _hoisted_12, _toDisplayString(confirmation.sequenceNumber || 'N/A'), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("div", _hoisted_13, [
                                                  _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-caption text-medium-emphasis font-weight-bold" }, "Mailed To", -1 /* HOISTED */)),
                                                  _createElementVNode("span", null, _toDisplayString(confirmation.mailedTo || 'N/A'), 1 /* TEXT */)
                                                ])
                                              ]),
                                              _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _: 1 /* STABLE */
                              }))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _createVNode(_component_v_navigation_drawer, {
          modelValue: $setup.overlayAffidavit,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.overlayAffidavit) = $event)),
          location: "right",
          temporary: "",
          width: "520"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { flat: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createTextVNode("Affidavit of Mailing")
                  ])),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_subtitle, null, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode("Exela vs MOE piece counts by sort group")
                  ])),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_data_table, {
                      headers: $setup.affidavitHeaders,
                      items: $setup.affidavitRows,
                      "items-per-page": -1,
                      "hide-default-footer": "",
                      density: "compact",
                      class: "elevation-0",
                      "row-props": $setup.affidavitRowProps
                    }, null, 8 /* PROPS */, ["headers", "items", "row-props"]),
                    _createVNode(_component_v_divider, { class: "my-2" }),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[19] || (_cache[19] = _createElementVNode("span", null, "Total", -1 /* HOISTED */)),
                      _createElementVNode("span", null, "Exela " + _toDisplayString($setup.affidavitTotals.exela) + " / MOE " + _toDisplayString($setup.affidavitTotals.moe), 1 /* TEXT */)
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _createCommentVNode(" Date Range Selection "),
        _createVNode(_component_v_row, {
          class: "mb-2",
          justify: "center",
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "4",
              md: "2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: $setup.fromDate,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.fromDate) = $event)),
                  label: "From Date",
                  type: "date",
                  variant: "outlined",
                  density: "comfortable",
                  "hide-details": ""
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "4",
              md: "2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: $setup.toDate,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.toDate) = $event)),
                  label: "To Date",
                  type: "date",
                  variant: "outlined",
                  density: "comfortable",
                  "hide-details": ""
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_col, { cols: "auto" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  "prepend-icon": "mdi-magnify",
                  onClick: $setup.fetchBatchSummaries,
                  disabled: !$setup.hasDateFilter
                }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode(" Search ")
                  ])),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick", "disabled"]),
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  "prepend-icon": "mdi-close",
                  onClick: $setup.clearDateFilter,
                  disabled: !$setup.hasDateFilter,
                  class: "ml-2"
                }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createTextVNode(" Clear ")
                  ])),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick", "disabled"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createCommentVNode(" No Results Message "),
        ($setup.hasSearched && $setup.batchSummaries.length === 0)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              class: "mb-6",
              justify: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_alert, {
                      type: "info",
                      variant: "tonal"
                    }, {
                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                        _createTextVNode(" No batches found for the selected date range. ")
                      ])),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Batch Selection "),
        ($setup.batchSummaries.length > 0)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              class: "mb-6",
              justify: "center",
              align: "start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: $setup.selectedBatchId,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.selectedBatchId) = $event)),
                      items: $setup.batchOptions,
                      "item-title": "text",
                      "item-value": "value",
                      label: "Select Batch Run",
                      variant: "outlined",
                      density: "comfortable"
                    }, {
                      item: _withCtx(({ props, item }) => [
                        _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                          append: _withCtx(() => [
                            _createVNode(_component_v_chip, {
                              color: $setup.batchValidationDisplay(item.raw.validationStatus).color,
                              size: "small",
                              class: "mr-2"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.batchValidationDisplay(item.raw.validationStatus).label), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"]),
                            _createVNode(_component_v_chip, {
                              color: item.raw.hasErrors ? 'error' : 'success',
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.raw.hasErrors ? 'Failed' : 'Successful'), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                      ]),
                      selection: _withCtx(({ item }) => [
                        _createElementVNode("span", null, _toDisplayString(item.title), 1 /* TEXT */),
                        _createVNode(_component_v_chip, {
                          color: $setup.batchValidationDisplay(item.raw.validationStatus).color,
                          size: "small",
                          class: "ml-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.batchValidationDisplay(item.raw.validationStatus).label), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"]),
                        _createVNode(_component_v_chip, {
                          color: item.raw.hasErrors ? 'error' : 'success',
                          size: "small",
                          class: "ml-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.raw.hasErrors ? 'Failed' : 'Successful'), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "items"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_col, { cols: "auto" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      "prepend-icon": "mdi-download",
                      onClick: $setup.downloadBatchSummary,
                      disabled: !$setup.selectedBatch
                    }, {
                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createTextVNode(" Download Summary ")
                      ])),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick", "disabled"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Dashboard Content (only show when batch is selected) "),
        ($setup.selectedBatch)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createCommentVNode(" Summary Cards "),
              _createVNode(_component_v_row, {
                class: "mb-6",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "card-border-left card-border-blue h-100" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-overline text-medium-emphasis font-weight-bold" }, "Total Processed", -1 /* HOISTED */)),
                              _createElementVNode("div", _hoisted_15, _toDisplayString($setup.selectedBatch.totalPoliciesProcessed), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "card-border-left card-border-green h-100" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _cache[25] || (_cache[25] = _createElementVNode("div", { class: "text-overline text-medium-emphasis font-weight-bold" }, "Successful", -1 /* HOISTED */)),
                              _createElementVNode("div", _hoisted_16, _toDisplayString($setup.successCount), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_17, _toDisplayString($setup.successRate) + "% success rate", 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "card-border-left card-border-orange h-100" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "text-overline text-medium-emphasis font-weight-bold" }, "Excluded", -1 /* HOISTED */)),
                              _createElementVNode("div", _hoisted_18, _toDisplayString($setup.excludedCount), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_19, _toDisplayString($setup.excludedRate) + "% excluded rate", 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "card-border-left card-border-red h-100" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _cache[27] || (_cache[27] = _createElementVNode("div", { class: "text-overline text-medium-emphasis font-weight-bold" }, "Failed", -1 /* HOISTED */)),
                              _createElementVNode("div", _hoisted_20, _toDisplayString($setup.failedCount), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_21, _toDisplayString($setup.failureRate) + "% failure rate", 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "card-border-left card-border-purple h-100" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "text-overline text-medium-emphasis font-weight-bold" }, "Total Pages", -1 /* HOISTED */)),
                              _createElementVNode("div", _hoisted_22, _toDisplayString($setup.totalPages), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: _normalizeClass(["card-border-left h-100", $setup.validationStatusBorderClass])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _cache[30] || (_cache[30] = _createElementVNode("div", { class: "text-overline text-medium-emphasis font-weight-bold" }, "Print Validation", -1 /* HOISTED */)),
                              _createVNode(_component_v_chip, {
                                class: "mt-2",
                                color: $setup.validationStatusColor,
                                size: "small",
                                label: "",
                                "prepend-icon": "mdi-circle"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.validationStatusLabel), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["color"]),
                              _createElementVNode("div", _hoisted_23, _toDisplayString($setup.affidavitTotals.exela) + " (Exela) of " + _toDisplayString($setup.affidavitTotals.moe) + " (MoE) pieces printed ", 1 /* TEXT */),
                              _createVNode(_component_m_btn, {
                                class: "mt-1",
                                style: {"cursor":"pointer"},
                                onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.overlayAffidavit = true))
                              }, {
                                default: _withCtx(() => _cache[29] || (_cache[29] = [
                                  _createTextVNode(" Affidavit of Mailing ")
                                ])),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["class"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }),
              _createCommentVNode(" Filter and Table "),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                          _createCommentVNode(" Filter Buttons "),
                          _createVNode(_component_v_card_text, { class: "pb-0" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_24, [
                                _createVNode(_component_v_btn_toggle, {
                                  modelValue: $setup.statusFilter,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.statusFilter) = $event)),
                                  mandatory: "",
                                  density: "comfortable"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      value: "all",
                                      color: "blue"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" All (" + _toDisplayString($setup.selectedBatch.policySummaries?.length || 0) + ") ", 1 /* TEXT */)
                                      ]),
                                      _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_btn, {
                                      value: "success",
                                      color: "success"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Successful (" + _toDisplayString($setup.successCount) + ") ", 1 /* TEXT */)
                                      ]),
                                      _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_btn, {
                                      value: "excluded",
                                      color: "warning"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Excluded (" + _toDisplayString($setup.excludedCount) + ") ", 1 /* TEXT */)
                                      ]),
                                      _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_btn, {
                                      value: "failed",
                                      color: "error"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Failed (" + _toDisplayString($setup.failedCount) + ") ", 1 /* TEXT */)
                                      ]),
                                      _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_btn, {
                                      value: "paperless",
                                      color: "info"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Paperless (" + _toDisplayString($setup.paperlessCount) + ") ", 1 /* TEXT */)
                                      ]),
                                      _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_btn, {
                                      value: "notpaperless",
                                      color: "blue-grey"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Not Paperless (" + _toDisplayString($setup.notPaperlessCount) + ") ", 1 /* TEXT */)
                                      ]),
                                      _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_btn, {
                                      value: "confirmed",
                                      color: "success"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Mailed (" + _toDisplayString($setup.mailedPieceCount) + ") ", 1 /* TEXT */)
                                      ]),
                                      _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_btn, {
                                      value: "notconfirmed",
                                      color: "warning"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Not Mailed (" + _toDisplayString($setup.notMailedPieceCount) + ") ", 1 /* TEXT */)
                                      ]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: $setup.tableSearch,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.tableSearch) = $event)),
                                  label: "Search all columns",
                                  "prepend-inner-icon": "mdi-magnify",
                                  variant: "outlined",
                                  density: "comfortable",
                                  clearable: "",
                                  "hide-details": "",
                                  style: {"max-width":"320px"}
                                }, null, 8 /* PROPS */, ["modelValue"])
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createCommentVNode(" Data Table "),
                          _createVNode(_component_v_data_table, {
                            headers: $setup.tableHeaders,
                            items: $setup.displayRows,
                            search: $setup.tableSearch,
                            "sort-by": [{ key: 'policyNumber', order: 'asc' }],
                            "item-key": "policyNumber",
                            class: "elevation-0",
                            density: "comfortable",
                            hover: ""
                          }, {
                            "item.policyNumber": _withCtx(({ item }) => [
                              _createElementVNode("span", _hoisted_25, _toDisplayString(item.policyNumber), 1 /* TEXT */)
                            ]),
                            "item.statusLabel": _withCtx(({ item }) => [
                              (item.docProdError)
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 0,
                                    color: "error",
                                    size: "small",
                                    "text-color": "white",
                                    "prepend-icon": "mdi-circle"
                                  }, {
                                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                                      _createTextVNode(" Failed ")
                                    ])),
                                    _: 1 /* STABLE */
                                  }))
                                : (item.successful)
                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                      key: 1,
                                      color: "success",
                                      size: "small",
                                      "text-color": "white",
                                      "prepend-icon": "mdi-circle"
                                    }, {
                                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                                        _createTextVNode(" Success ")
                                      ])),
                                      _: 1 /* STABLE */
                                    }))
                                  : (item.excludedByTracker || item.excludedByDocProd)
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 2,
                                        color: "warning",
                                        size: "small",
                                        "text-color": "white",
                                        "prepend-icon": "mdi-circle"
                                      }, {
                                        default: _withCtx(() => _cache[33] || (_cache[33] = [
                                          _createTextVNode(" Excluded ")
                                        ])),
                                        _: 1 /* STABLE */
                                      }))
                                    : (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 3,
                                        color: "error",
                                        size: "small",
                                        "text-color": "white",
                                        "prepend-icon": "mdi-circle"
                                      }, {
                                        default: _withCtx(() => _cache[34] || (_cache[34] = [
                                          _createTextVNode(" Failed ")
                                        ])),
                                        _: 1 /* STABLE */
                                      }))
                            ]),
                            "item.totalPages": _withCtx(({ item }) => [
                              _createElementVNode("span", _hoisted_26, _toDisplayString(item.totalPages), 1 /* TEXT */)
                            ]),
                            "item.processingTime": _withCtx(({ item }) => [
                              _createElementVNode("span", _hoisted_27, _toDisplayString(item.processingTime), 1 /* TEXT */)
                            ]),
                            "item.formCodes": _withCtx(({ item }) => [
                              (item.formCodes && item.formCodes.length > 0)
                                ? (_openBlock(), _createBlock(_component_m_btn, {
                                    key: 0,
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => ($setup.selectBatchPolicySummary(item))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" View (" + _toDisplayString(item.formCodes.length) + ") ", 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                                : _createCommentVNode("v-if", true),
                              (!item.formCodes || item.formCodes.length === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, " N/A "))
                                : _createCommentVNode("v-if", true)
                            ]),
                            "item.batchName": _withCtx(({ item }) => [
                              _createElementVNode("span", _hoisted_29, _toDisplayString(item.batchName), 1 /* TEXT */)
                            ]),
                            "item.isPaperlessLabel": _withCtx(({ item }) => [
                              _createElementVNode("span", _hoisted_30, _toDisplayString(item.isPaperlessLabel), 1 /* TEXT */)
                            ]),
                            "item.printStatus": _withCtx(({ item }) => [
                              (item.printStatus === 'N/A')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, " N/A "))
                                : (item.printStatus === 'Pending')
                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                      key: 1,
                                      color: "grey",
                                      size: "small",
                                      "text-color": "white",
                                      "prepend-icon": "mdi-clock-outline"
                                    }, {
                                      default: _withCtx(() => _cache[35] || (_cache[35] = [
                                        _createTextVNode(" Pending ")
                                      ])),
                                      _: 1 /* STABLE */
                                    }))
                                  : (item.printStatus === 'Mailed')
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 2,
                                        color: "success",
                                        size: "small",
                                        "text-color": "white",
                                        "prepend-icon": "mdi-check-circle",
                                        style: {"cursor":"pointer"},
                                        onClick: ($event: any) => ($setup.selectPrintConfirmations(item))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Mailed (" + _toDisplayString(item.printConfirmations.length) + ") ", 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                                    : (item.printStatus === 'Partial')
                                      ? (_openBlock(), _createBlock(_component_v_chip, {
                                          key: 3,
                                          color: "warning",
                                          size: "small",
                                          "text-color": "white",
                                          "prepend-icon": "mdi-alert",
                                          style: {"cursor":"pointer"},
                                          onClick: ($event: any) => ($setup.selectPrintConfirmations(item))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Partial (" + _toDisplayString(item.printConfirmations.length) + " of " + _toDisplayString(item.expectedPieces) + ") ", 1 /* TEXT */)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                                      : (_openBlock(), _createBlock(_component_v_chip, {
                                          key: 4,
                                          color: "error",
                                          size: "small",
                                          "text-color": "white",
                                          "prepend-icon": "mdi-alert-circle",
                                          style: {"cursor":"pointer"},
                                          onClick: ($event: any) => ($setup.selectPrintConfirmations(item))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Not Mailed (" + _toDisplayString(item.missingPieces) + ") ", 1 /* TEXT */)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                            ]),
                            "item.details": _withCtx(({ item }) => [
                              (item.docProdError)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString($setup.getFailureReason(item)), 1 /* TEXT */))
                                : (item.successful)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString($setup.getArchivalStatus(item)), 1 /* TEXT */))
                                  : (item.excludedByTracker || item.excludedByDocProd)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString($setup.getFailureReason(item)), 1 /* TEXT */))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString($setup.getFailureReason(item)), 1 /* TEXT */))
                            ]),
                            "no-data": _withCtx(() => _cache[36] || (_cache[36] = [
                              _createElementVNode("div", { class: "text-center pa-8 text-medium-emphasis" }, " No policies found for the selected filter. ", -1 /* HOISTED */)
                            ])),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["headers", "items", "search"])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ], 64 /* STABLE_FRAGMENT */))
}